import { FontWeight } from "../../globalStyles/emotion";
import { formatCurrency } from "../../utils/formatCurrency";

import "./Payout.css";
const Payout = ({
  bonus,
  estimatedPayout,
  actualTotal,
  estimatedTotal,
  suppressPayment,
}) => {
  estimatedPayout = formatCurrency(estimatedPayout);
  bonus = formatCurrency(bonus);

  let total = formatCurrency(estimatedTotal);

  // On the HistoryView, use actual total instead of estimated total
  // If the actual total hasn't been calculated yet, display "TBD"
  if (actualTotal !== undefined && actualTotal !== null) {
    total = formatCurrency(actualTotal);
  } else if (actualTotal !== undefined && actualTotal === null) {
    total = "TBD";
  }

  return (
    <>
      <div style={{ display: "flex", gap: "5px" }}>
        <p style={{ width: "62px" }}>Payout: </p>
        <FontWeight>{suppressPayment ? "N/A" : estimatedPayout}</FontWeight>
      </div>

      {localStorage.getItem("Page") === "Dispatch" ? null : (
        <div style={{ display: "flex", gap: "5px" }}>
          <p style={{ width: "62px" }}> Total: </p>{" "}
          <FontWeight>{suppressPayment ? "N/A" : total}</FontWeight>
        </div>
      )}
    </>
  );
};

export default Payout;
